export class CacheKey {

  public static MemberInfo = 'MemberInfo';
  public static Configuration = 'Configuration';
  public static DefaultLanguage = 'DefaultLanguage';
  public static SSOToken = 'access_token';
  public static UserInfo = 'userInfo';
  public static CountryId = 'countryId';
  public static NavigateToShopCheckout = 'NavigateToShopCheckout';
  public static RecentlyViewedProducts = 'RecentlyViewedProducts';
  public static ImpersonatedUser = 'impersonatedUser';
  public static CartSessionInfo = 'CartSessionInfo';
  public static CategoriesTree = 'CategoriesTree';
  public static Countries = 'Countries';
  public static GuestUser = 'GuestUser';
  public static CartItems = 'CartItems';
  public static Nav_path = 'Nav_path';
  public static CheckoutInformation = 'CheckoutInformation';
  public static EnrollSessionGuid = 'EnrollSessionGuid';
  public static AutoPopulate = 'AutoPopulate';
  public static CustomerPaymentTokenId = 'CustomerPaymentTokenId';
  public static CardTokenDetails = 'CardTokenDetails';
  public static OpaqueDetails = 'OpaqueDetails';
  public static HeaderSearch = 'HeaderSearch';
  public static WishListSession = 'WishListSession';
  public static Refresh_token = 'refresh_token';
  public static IsCountryChange = 'IsCountryChange';
  public static CountryChange = 'CountryChange';
  public static StoreConfiguration = 'StoreConfiguration';
  public static BrowsedProducts = 'browsed-products';
  public static Impersonation = 'impersonation';
  public static SelectedCategoryState = 'SelectedCategoryState';
  public static SelectedCategoryId = 'SelectedCategoryId';
  public static AutoshipCart = 'AutoshipCart';
  public static fboId = 'fboId';
  public static ShareFBODetails = 'ShareFBODetails';
  public static OrderRules = 'OrderRules';
  public static ModuleId = 'ModuleId';
  public static Menus = 'menus';
  public static CountryLangSettings = 'countryLanguageSettings';
  public static CookieBanner = 'cookiebanner';
  public static CartSessionGuid = 'cartSessionGuid';
  public static countryCode = 'countryCode';
  public static languageCode = 'languageCode';
  public static CountryName = 'countryName';
  public static Language = 'language';
  public static IsUserLogout = 'IsUserLogout';
  public static ClearCart = 'ClearCart';
  public static hasCartItems = 'hasCartItems';
  public static RecentSearch = 'recentSearch';
  public static isSiteFirstLoad = 'isSiteFirstLoad';
  public static SplashScreen = 'SplashScreen';
  public static PortalCountries = 'portalCountries';
  public static RedirectToFavourites = 'RedirectToFavourites';
  public static WishListProduct = 'WishListProduct';
  public static CartSummary = 'CartSummary';
  public static MyActionCenterModalDisplayed = 'MyActionCenterModalDisplayed';
  public static session_state = 'session_state';
  public static DocumentStatus = 'DocumentStatus';
  public static HasUpgradeAsFBO = 'HasUpgradeAsFBO';
  public static MemberSessionGuid = 'MemberSessionGuid';
  public static CanShowNotification = 'CanShowNotification';
  public static FPCWholesaleQualified = 'FPCWholesaleQualified';
  public static loggedOut = 'loggedOut';
  public static PreviewConfig = 'previewConfig';
  public static SiteMaps = 'SiteMaps';
  public static LanguageDisplayDirection = 'LanguageDisplayDirection';
  public static MemberDiscountPercentage = 'MemberDiscountPercentage';
  public static Store_Portal_Features = 'StorePortalFeatures';
  public static Flp360LoginClicked = 'Flp360LoginClicked';
  public static MemberSalePromotionModel = 'memberSalePromotionModel';
  public static CountryMetaData = 'CountryMetaData';
  public static MemberOrderRestrictionInfo = 'MemberOrderRestrictionInfo';
}
